// ng2-validators (Angular 19 非対応) の PasswordValidators.mismatchedPasswords 互換実装。
// newPassword / confirmPassword を持つ FormGroup 用。
import {AbstractControl, ValidatorFn} from '@angular/forms';

export class PasswordValidators {
    static mismatchedPasswords(passwordName = 'newPassword', confirmName = 'confirmPassword'): ValidatorFn {
        return (group: AbstractControl) => {
            const password = group.get(passwordName);
            const confirm = group.get(confirmName);
            if (!password || !confirm) {
                return null;
            }
            if (password.value !== confirm.value) {
                confirm.setErrors({...(confirm.errors || {}), mismatchedPasswords: true});
                return {mismatchedPasswords: true};
            }
            if (confirm.errors) {
                const {mismatchedPasswords, ...rest} = confirm.errors;
                confirm.setErrors(Object.keys(rest).length ? rest : null);
            }
            return null;
        };
    }
}
